module.exports = __webpack_public_path__ + "img/DealerIcons-i2-Off.a5053db.jpg";